import { connect } from 'react-redux';
import {
  getDocumentTitleById,
  getDocumentDescriptionById,
  getDocumentPublishedByById,
  getDocumentDateById,
  getGroupTitleByGroupId,
  getDocumentPublishedByUrlById,
  getResourceImage,
  getResourceFile,
  getResourcesLikeById,
  getResourcesReadById,
  getDocumentTypeByUrlById,
  getResourcesReadTimeById,
  getResourcesReadDateById,
} from 'store/selectors/resources';
import Page from 'components/ResourcePage/Page';
import {
  resourcesOpenPdf,
  resourcesLikeResource,
  resourcesReadResource,
} from 'store/actionCreators/resources';

const mapStateToProps = (state, { resourceId, groupId }) => ({
  date: getDocumentDateById(resourceId)(state),
  description: getDocumentDescriptionById(resourceId)(state),
  publishedBy: getDocumentPublishedByById(resourceId)(state),
  publishedByUrl: getDocumentPublishedByUrlById(resourceId)(state),
  groupTitle: getGroupTitleByGroupId(groupId)(state),
  like: getResourcesLikeById(resourceId)(state),
  isRead: !!getResourcesReadById(resourceId)(state),
  readTime: getResourcesReadTimeById(resourceId)(state),
  readDate: getResourcesReadDateById(resourceId)(state),
  documentType: getDocumentTypeByUrlById(resourceId)(state),
  image: getResourceImage(state),
  isFile: !!getResourceFile(state),
  title: getDocumentTitleById(resourceId)(state),
});

const mapDispatchToProps = dispatch => ({
  openPdf: () => dispatch(resourcesOpenPdf()),
  onClickLike: like => dispatch(resourcesLikeResource(like)),
  onClickMarkAsRead: () => dispatch(resourcesReadResource()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Page);
